import {
	getCustomerTag
} from '@/api/customer'
const state = {
	customeTag: []
};
const mutations = {
	SET_CUSTOME_TAG: (state, list) => {
		console.log(list)
		state.customeTag = list;
	}
};
const actions = {
	GetCustomerTag({
		commit
	}) {
		return new Promise((resolve, reject) => {
			getCustomerTag().then((res) => {
					if (res.errcode === 0) {
						const temp = res.data.reduce((acc, item) => {
							if (acc[item.type]) {
								acc[item.type].children.push(item)
							} else {
								if(item.typeName){
									if(item.type != 1 && item.type != 2 && item.type != 3 && item.type != 4 ){
										acc[item.type] = {
											label: item.typeName,
											value: item.type,
											children: [item]
										}
									}
								}
							}
							return acc
						}, {})
						commit('SET_CUSTOME_TAG', Object.values(temp))
						resolve(Object.values(temp))
					}
				})
				.catch((err) => {
					reject(err)
				})
		});
	}
};

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
